export { metadata } from './modules/sync_akeneo/index'
